import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension, CustomFieldExtensionSchema } from '@backstage/plugin-scaffolder-react';
import {
  RichTextEditor,
  RichTextEditorSchema,
} from './RichTextEditor';

export const RichTextEditorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'RichTextEditor',
    component: RichTextEditor,
    schema: RichTextEditorSchema as CustomFieldExtensionSchema,
  }),
);